module.exports = __webpack_public_path__ + "img/facebook.4d5d9383.svg";